import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import useResource from '../custom-hooks/useResource'
import SEO from './../utils/SEOMetaTags'
import { 
    ShowAboutLayout, 
    Loading,
    SocialShareBlock,
    AirDateFormatter } from '@scrippsproduct/scripps-external-component-library'
import PageNotFound from './PageNotFound'
import { getUpcomingAirDates } from '@scrippsproduct/scripps-external-component-library/dist/utils/getUpcomingPrograms'
import { convert12to24 } from '@scrippsproduct/scripps-external-component-library/dist/utils/helpers'

import './../scss/ShowDetails.scss'

const SCHEDULE_ENDPOINT = process.env.REACT_APP_SCHEDULE_V2
const NETWORK = process.env.REACT_APP_NETWORK

function MovieDetails() {
    const urlParams = useParams()
    const movieList = useResource({
        cacheName: `movieDetails:${urlParams.slug}`,
        resourceName: 'movieDetails', 
        resourceId: urlParams.slug, 
        queryVars: {id: `slug = ${urlParams.slug}`}
    })
    const [movie, setMovie] = useState(null)
    const [nextAirdates, setNextAirdates] = useState([])
    const [showUpcoming, setShowUpcoming] = useState(false)

    useEffect(() => {
        ;(async () => {
            if (movieList?.data !== undefined && movieList?.isSuccess && movieList?.data?.MovieList?.length) {
                setMovie(movieList.data.MovieList[0])
                const programs = await getUpcomingAirDates({
                    programId: movieList.data.MovieList[0].titleCode, 
                    programType: 'film', 
                    maxResults: 6, 
                    SCHEDULE_ENDPOINT, 
                    NETWORK
                
                })
                const airdates = programs.map(progam => (<AirDateFormatter airdateStr={`${progam.start_date_parse} ${convert12to24(progam.start_time)}`}/>))
                setNextAirdates([...airdates])
                setShowUpcoming(true)
            }
        })()                        
    }, [movieList.isSuccess, movieList.data])
    
    if ((movieList.isSuccess && movie === null) || movieList.isError) return (
        <section className="info-page">
            <content-constrainer>
                <PageNotFound message={`We can't find the show ${urlParams.slug.replace('-', ' ').toUpperCase()}.`} page={{name: 'shows', path: '/shows'}}/>
            </content-constrainer>
        </section>
    )

    return (<show-details-page>
        { (movieList.isSuccess && movie !== null) && <> 
            <SEO
                title={`${movie.title.replace(/<br\s*\/?>/i, ' ')} | Movie | Grit`}
                description={`${movie.series_synopsis}`}
            /> 
             <section className="page-section">
                <content-constrainer class="content-constrainer--no-border details-header">
                    <a href="/movies" className="return-to-list-btn">View Upcoming Primetime Movies</a>
                    <SocialShareBlock 
                        url={window.location.href}
                        text={movie?.synopsis}
                        longtext={movie.description}
                    />
                </content-constrainer>
            </section>
        </>}

        {(movieList.isSuccess && movie !== null) &&             
            <content-constrainer class="content-constrainer--no-padding content-constrainer--no-border">
                { (movie !== null && movieList.isSuccess) && 
                    <ShowAboutLayout 
                        series={{
                            title: movieList.data.MovieList[0].title,
                            series_synopsis: movieList.data.MovieList[0].series_synopsis,
                            cast: movieList.data.MovieList[0].cast,
                            creators: movieList.data.MovieList[0]?.creators,
                            public_content: movieList.data.MovieList[0]?.public_content,
                            detailImage: (movieList.data.MovieList[0]?.featuredImage) ? movieList.data.MovieList[0]?.featuredImage : (movieList.data.MovieList[0]?.detailImage) ? movieList.data.MovieList[0]?.detailImage : null,
                            genres: movieList.data.MovieList[0]?.genres,
                            rating: movieList.data.MovieList[0]?.rating,
                            year_released: movieList.data.MovieList[0]?.year_released,          
                        }}
                        type="film"
                        showUpcoming={showUpcoming}
                        nextAirdates={nextAirdates}
                        firstColumnWidth="min(50%, 543px)"
                     /> 
                }
                { (movieList.isLoading) && <Loading topOffset={`10rem`} spinnerColor={`hsl(0deg 0% 86.68% / 77%)`} />}
            </content-constrainer>
        }
    </show-details-page>)
}

export default MovieDetails